import { Card, Col, Form, Row } from 'react-bootstrap';

import { ECONOMY_FIELDS, MARATHON_ECONOMY_DEFAULTS, MEconomy } from '../utils';

type Props = {
  economy: MEconomy;
  onUpdate: (patch: Partial<MEconomy>) => void;
};

export function MarathonEconomyData({ economy, onUpdate }: Props): JSX.Element {
  return (
    <Card style={{ width: '100%', marginBottom: 10 }}>
      <Card.Header className="text-center">
        <Card.Title>Economy</Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          {ECONOMY_FIELDS.map(({ key, label }) => {
            const value = economy[key];
            const isInvalid = !Number.isInteger(value) || value < 0;
            return (
              <Col md={4} key={key}>
                <Form.Group controlId={`marathon-economy-${key}`}>
                  <Form.Label>{label}</Form.Label>
                  <Form.Control
                    type="number"
                    min={0}
                    step={1}
                    value={Number.isNaN(value) ? '' : value}
                    isInvalid={isInvalid}
                    onChange={(e) => {
                      onUpdate({ [key]: e.target.value === '' ? NaN : Number(e.target.value) });
                    }}
                  />
                  <Form.Control.Feedback type="invalid">Must be an integer ≥ 0</Form.Control.Feedback>
                  <Form.Text muted>Default: {MARATHON_ECONOMY_DEFAULTS[key]}</Form.Text>
                </Form.Group>
              </Col>
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
}
